
<div class="h-100">
    <c-column-header label="Gefahren" class="primary" :title-border="true" v-if="showTitle" />
    <div class=" pr-0 " style="height: calc(100% - 34px)" :class="showTitle ? 'lm-border mt-1' : ''">
        <div class=" ml-0 pr-0 pl-0">
            <div v-for="(item, index) in all" :key = "index">
                <p-audit-select-item
                    :index    = "index+1"
                    :item     = "item"
                    :selected = "selected(item)"
                    selected-color = "black--text"
                />
                <v-divider />
            </div>
        </div>

        <v-row class="no-frame pa-3 mt-5">
            <v-col class="no-frame">
                <p-audit-measure
                    label="Empfohlene Maßnamen"
                    :text="measures"
                />
            </v-col>
        </v-row>
    </div>
</div>
